import type { PropsWithChildren } from 'react'
import type { OauthYahooRelationError } from '~/lib/member/relationError'
import {
  ppgHelpContactUrl,
  ppgHelpMailAddressUrl,
  ppgHelpYahooIdUrl,
  yahooProfileEditUrl,
} from '~/lib/url'
import { css } from '~/styled-system/css'

export function YahooMemberRelationError({ error }: { error: OauthYahooRelationError }) {
  switch (error.type) {
    case 'OauthAlreadyRelatedOtherUser':
      return <OauthAlreadyRelatedOtherUser />
    case 'StopUser':
      return <StopUser />
    case 'LoginErrorAccountLockout':
      return <LoginErrorAccountLockout />
    case 'MailAddressNotCertificated':
      return <MailAddressNotCertificated />
    case 'YahooMailAddressNotCertificated':
      return <YahooMailAddressNotCertificated />
    case 'IkyuAndYahooMailAddressNotCertificated':
      return <IkyuAndYahooMailAddressNotCertificated />
    case 'InvalidOauthRefreshToken':
      return <InvalidOauthRefreshToken />
    case 'BlackMailAddress':
      return <BlackMailAddress email={error.email} />
  }
}

function OauthAlreadyRelatedOtherUser() {
  return (
    <div>
      ログイン中のYahoo! JAPAN IDに登録されているメインメールアドレスは、別のYahoo!
      JapanIDと連携済みの「一休.com会員アカウント」に登録されています。ログイン中のYahoo! JAPAN
      IDで予約を行いたい場合は、
      <Link href={yahooProfileEditUrl}>登録情報の編集画面</Link>
      よりメインメールアドレスを変更してください。詳細は
      <Link href={ppgHelpMailAddressUrl}>こちら</Link>
    </div>
  )
}

function StopUser() {
  return (
    <div>
      株式会社一休の規約に則り、お客様のアカウントでのご予約は受け付けられません。
      恐れ入りますが、詳細については
      <Link href={ppgHelpContactUrl}>株式会社一休</Link>
      へお問い合わせください。
    </div>
  )
}

function LoginErrorAccountLockout() {
  return (
    <div>
      お客様のアカウントは現在ご利用いただけません。 恐れ入りますが、詳細については
      <Link href={ppgHelpContactUrl}>株式会社一休</Link>
      へお問い合わせください。
    </div>
  )
}

function MailAddressNotCertificated() {
  return (
    <div>
      ログイン中のYahoo!JAPAN
      IDに登録されているメインメールアドレスは、一休.comサイトでは「未認証」の状態です。本人確認のため、一休.comサイトにてログイン後、メールアドレスの認証をお願いします。認証完了後に予約できます。認証方法は
      <Link href={ppgHelpYahooIdUrl}>こちら</Link>
      をご参照ください。
    </div>
  )
}

function YahooMailAddressNotCertificated() {
  return (
    <div>
      ログイン中のYahoo! JAPAN
      IDに登録されているメインメールアドレスは「未確認」の状態です。メインメールアドレスに設定されている「連絡用メールアドレス」の確認をお願いします。確認完了後に予約が可能となります。連絡用メールアドレスの確認方法については、Yahoo!
      JAPAN IDに関するヘルプをご参照ください。
    </div>
  )
}

function IkyuAndYahooMailAddressNotCertificated() {
  return (
    <div>
      ログイン中のYahoo! JAPAN
      IDに登録されているメインメールアドレスは「未確認」で、一休.comサイトでも「未認証」の状態です。ご予約手続きに進むためには、
      「①Yahoo!JAPANサイト上での、メインメールアドレスに設定されている連絡用メールアドレスの確認」と、「②一休.comサイト上での、ログイン後のメールアドレスの認証」が必要です。①の方法については
      Yahoo!JAPAN IDに関するヘルプ、②の方法については
      <Link href={ppgHelpYahooIdUrl}>こちら</Link>
      をご参照ください。
    </div>
  )
}

function InvalidOauthRefreshToken() {
  return <div>ログイン時間が切れました。恐れ入りますが、再度ログインしてください。</div>
}

function BlackMailAddress({ email }: { email: string }) {
  return (
    <div>
      株式会社一休の規約に則り、メールアドレス{email}
      でのご予約は受け付けられません。恐れ入りますが、詳細については
      <Link href={ppgHelpContactUrl}>株式会社一休</Link>
      へお問い合わせください。
    </div>
  )
}

function Link({ href, children }: PropsWithChildren<{ href: string }>) {
  return (
    <a href={href} target="_blank" className={css({ color: 'link' })}>
      {children}
    </a>
  )
}
